import React from "react";
import { Link } from "react-router-dom";

// Speech-bubble CTA: coloured body, rounded top corners, pointed tail.
export default function SpeechBubble({ to, onClick, children, className = "" }) {
  const cls = `ro-bubble ${className}`;
  if (to) {
    return (
      <Link to={to} className={cls}>
        {children}
      </Link>
    );
  }
  return (
    <button type="button" className={cls} onClick={onClick}>
      {children}
    </button>
  );
}
